<script>
import { createEventDispatcher } from "svelte";
const dispatch = createEventDispatcher();

//
// Component state
//

let lament = ""
let isLamentSubmitted = false;

//
// Component methods
//

function submitLament() {
    if (!lament) {
        return;
    }
    dispatch('submit', lament)
    isLamentSubmitted = true;
}

function reset() {
    lament = "";
    isLamentSubmitted = false;
}

//
// Event handlers
//

const onNavigate = (page) => () => {
    dispatch('navigate', page);
}

</script>

<article class="splash card">
{#if !isLamentSubmitted}
    <h2>Offer up your lament</h2>
    <form class="pure-form pure-form-stacked">
        <fieldset class="pure-group">
            <textarea class="pure-input-1" rows="4" bind:value={lament} ></textarea>
        </fieldset>
        <br />
        <input type="submit" on:click|preventDefault={submitLament} class="pure-button button-primary button-round" value="Lift up" />
    </form>
    <p />
{:else}
    <h2>Lament submitted</h2>
    <p>Your lament has been lifted up. You can choose to submit another lament, receive a lament, or return home</p>
    <button class="pure-button" on:click="{onNavigate('home')}" >Home</button>
    <button class="pure-button" on:click="{reset}" >Lift up</button>
    <button class="pure-button" on:click="{onNavigate('receive')}" >Receive</button>
{/if}
</article>


<style>

</style>